import React, { useState } from "react";
import axios from "axios";
import { Send, Phone, Mail, MapPin, Clock, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ nev: "", email: "", telefon: "", uzenet: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.nev || !form.telefon || !form.uzenet) {
      setError("Kérjük töltse ki a név, telefon és üzenet mezőket.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      setDone(true);
      setForm({ nev: "", email: "", telefon: "", uzenet: "" });
    } catch (err) {
      setError("Hiba történt. Próbálja újra vagy hívjon közvetlenül.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="kapcsolat" data-testid="contact-section" className="border-b-2 border-[#FFD700]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
            [ 07 / Kapcsolat ]
          </div>
          <h2 className="font-heading uppercase text-5xl md:text-7xl leading-[0.9] mb-8">
            Hívjon<br />
            <span className="text-[#FFD700]">most.</span>
          </h2>
          <p className="text-[#A3A3A3] mb-8 text-lg">
            Ha kérdése van, vagy ajánlatot kérne — írjon, és 1 munkanapon belül válaszolunk.
            Vészhelyzetben azonnal hívjon!
          </p>

          <div className="space-y-4 font-mono">
            <a href="tel:+36204565627" data-testid="contact-phone" className="flex items-center gap-4 p-4 border border-[#262626] hover:border-[#FFD700] transition-colors group">
              <Phone className="w-5 h-5 text-[#FFD700]" />
              <div>
                <div className="text-xs text-[#A3A3A3] uppercase tracking-widest">0-24 Telefon · Varga Martin</div>
                <div className="text-xl text-white group-hover:text-[#FFD700] transition-colors">+36 20 456 5627</div>
              </div>
            </a>
            <a href="tel:+36708025019" data-testid="contact-phone-2" className="flex items-center gap-4 p-4 border border-[#262626] hover:border-[#FFD700] transition-colors group">
              <Phone className="w-5 h-5 text-[#FFD700]" />
              <div>
                <div className="text-xs text-[#A3A3A3] uppercase tracking-widest">0-24 Ügyelet</div>
                <div className="text-xl text-white group-hover:text-[#FFD700] transition-colors">+36 70 802 5019</div>
              </div>
            </a>
            <a href="mailto:martin@vargavolt.hu" data-testid="contact-email" className="flex items-center gap-4 p-4 border border-[#262626] hover:border-[#FFD700] transition-colors group">
              <Mail className="w-5 h-5 text-[#FFD700]" />
              <div>
                <div className="text-xs text-[#A3A3A3] uppercase tracking-widest">Email</div>
                <div className="text-xl text-white group-hover:text-[#FFD700] transition-colors">martin@vargavolt.hu</div>
              </div>
            </a>
            <div className="flex items-center gap-4 p-4 border border-[#262626]">
              <MapPin className="w-5 h-5 text-[#FFD700]" />
              <div>
                <div className="text-xs text-[#A3A3A3] uppercase tracking-widest">Székhely</div>
                <div className="text-lg text-white">2764 Tápióbicske, Klapka telep 23.</div>
                <div className="text-xs text-[#A3A3A3] mt-1">Országos kiszállás · 200-300 km körzet</div>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 border border-[#262626]">
              <Clock className="w-5 h-5 text-[#FFD700]" />
              <div>
                <div className="text-xs text-[#A3A3A3] uppercase tracking-widest">Nyitvatartás</div>
                <div className="text-lg text-white">H-V · 0-24 · Vészhelyzet</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <form onSubmit={submit} data-testid="contact-form" className="card-hi space-y-4">
            <div className="font-mono text-xs uppercase tracking-widest text-[#FFD700] mb-2">
              Üzenj nekünk
            </div>

            {done ? (
              <div data-testid="contact-success" className="flex items-start gap-3 p-4 border-2 border-[#FFD700] bg-[#FFD700]/10">
                <CheckCircle2 className="w-6 h-6 text-[#FFD700] mt-0.5 shrink-0" />
                <div>
                  <div className="font-heading uppercase text-lg">Megkaptuk!</div>
                  <p className="font-mono text-sm text-[#A3A3A3] mt-1">
                    Köszönjük az üzenetet. 1 munkanapon belül felvesszük Önnel a kapcsolatot.
                  </p>
                  <button
                    type="button"
                    onClick={() => setDone(false)}
                    className="mt-3 font-mono text-xs uppercase tracking-widest text-[#FFD700] hover:underline"
                  >
                    → Új üzenet
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div>
                  <label className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3] block mb-2">Név *</label>
                  <input
                    data-testid="contact-name"
                    className="input-brutal"
                    placeholder="Kovács János"
                    value={form.nev}
                    onChange={update("nev")}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3] block mb-2">Telefon *</label>
                    <input
                      data-testid="contact-telefon"
                      className="input-brutal"
                      placeholder="+36 30 123 4567"
                      value={form.telefon}
                      onChange={update("telefon")}
                    />
                  </div>
                  <div>
                    <label className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3] block mb-2">Email</label>
                    <input
                      data-testid="contact-email-input"
                      className="input-brutal"
                      placeholder="email@pelda.hu"
                      value={form.email}
                      onChange={update("email")}
                    />
                  </div>
                </div>
                <div>
                  <label className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3] block mb-2">Üzenet *</label>
                  <textarea
                    data-testid="contact-message"
                    className="input-brutal min-h-[140px] resize-y"
                    placeholder="Írja le röviden a problémát vagy a kért munkát..."
                    value={form.uzenet}
                    onChange={update("uzenet")}
                  />
                </div>
                {error && <div data-testid="contact-error" className="font-mono text-sm text-[#FF3333]">{error}</div>}
                <button
                  type="submit"
                  data-testid="contact-submit"
                  disabled={sending}
                  className="btn-primary w-full justify-center disabled:opacity-60"
                >
                  <Send className="w-4 h-4" />
                  {sending ? "Küldés..." : "Üzenet küldése"}
                </button>
                <p className="font-mono text-[10px] text-[#A3A3A3]">
                  Az űrlap elküldésével elfogadja adatkezelési tájékoztatónkat.
                </p>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
